// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lfb9","icon":"styles_icon__3FTL4"};